import { createContext, useContext, useEffect, useState } from 'react';
import { getInitialLanguage } from '@/i18n';

const LanguageContext = createContext({
  language: 'is',
  setLanguage: () => {},
});

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(getInitialLanguage());

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('lang', language);
    }
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}

export default LanguageContext;
